module.exports = __webpack_public_path__ + "static/img/more.6858b93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/more.png
// module id = uZp0
// module chunks = 4